import { render, staticRenderFns } from "./SectionAddress.vue?vue&type=template&id=9fd61bb2&scoped=true&"
import script from "./SectionAddress.vue?vue&type=script&lang=js&"
export * from "./SectionAddress.vue?vue&type=script&lang=js&"
import style0 from "./SectionAddress.vue?vue&type=style&index=0&id=9fd61bb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd61bb2",
  null
  
)

export default component.exports